@if (url) {
  <img [src]="url" alt="" aria-hidden="true" style="position: absolute; width: 0; height: 0" loading="lazy" />
}
